import { render, staticRenderFns } from "./SystemTopbar.vue?vue&type=template&id=b98e042c&"
import script from "./SystemTopbar.vue?vue&type=script&lang=js&"
export * from "./SystemTopbar.vue?vue&type=script&lang=js&"
import style0 from "./SystemTopbar.vue?vue&type=style&index=0&id=b98e042c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports